
import CardPos from "../../../assets/filled/CardPos.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardPosIcon({ className, dataTestid = "CardPosIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardPos data-testid={dataTestid} className={classes} {...rest} />
  );
}
